import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getDashboardAnalyticsApi } from "./dashboardApi";

export const getDashboardAnalytics = createAsyncThunk(
  "dashboard/getAnalytics",
  async (params, thunkAPI) => {
    try {
      const query = {};

      if (params?.locationId) {
        query.locationId = params.locationId;
      }

      const res = await getDashboardAnalyticsApi(query);
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || "Something went wrong"
      );
    }
  }
);

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    analytics: null,
    loading: false,
    error: null,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder

      .addCase(getDashboardAnalytics.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(getDashboardAnalytics.fulfilled, (state, action) => {
        state.loading = false;
        state.analytics = action.payload;
      })

      .addCase(getDashboardAnalytics.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

export default dashboardSlice.reducer;